import classNames from 'classnames';
import React, {useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import NotificationsFormWarning from '../../scenes/Form/components/AccountSettingsForm/components/NotificationsFormWarning';

const BasicSlideToggle = props => {
  const {
    name,
    value,
    onChange,
    checked,
    label,
    renderLabel,
    help,
    mark,
    disabled,
    error,
    labelPosition = 'left',
    trackStyle = {},
    dotStyle= {}
  } = props;

  const handleChange = useCallback(() => {
    if (!disabled) {
      onChange(name, value || !checked, !checked);
    }
  }, [name, value, disabled, checked, onChange]);

  const dotStyles = useMemo(() => ({
    backgroundColor: !disabled ? '#fff' : '#bdbdbd',
    ...dotStyle
  }), [disabled, dotStyle]);

  return (
    <label
      className={
        classNames({
          'basic-slide-toggle__container': true,
          'basic-slide-toggle__container--disabled': disabled,
          'basic-slide-toggle__container--right': labelPosition === 'right',
          'basic-slide-toggle__container--left': labelPosition === 'left',
        })
      }
    >
      <input
        checked={checked}
        onChange={handleChange}
        className="basic-slide-toggle"
        type="checkbox"
      />
      <div className="basic-slide-toggle__track" style={trackStyle} >
        <div className="basic-slide-toggle__dot" style={dotStyles} />
      </div>

      <span className="basic-slide-toggle__content">
        <span className={'basic-slide-toggle__label'}>
          {renderLabel ? renderLabel : label}
          {mark && <span className={'basic-slide-toggle__mark'}>{mark}</span>}
        </span>
        {help && <span className={'basic-slide-toggle__help'}>{help}</span>}
        {!!error && (
          <NotificationsFormWarning>{error}</NotificationsFormWarning>
        )}
      </span>
    </label>
  );
};

BasicSlideToggle.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  labelStyles: PropTypes.object,
  disabled: PropTypes.bool,
};

export default BasicSlideToggle;
